import { Component, OnInit, ViewEncapsulation, Inject, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { OrganizationApprovalInfo } from '../model/OrganizationApprovalInfo';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { WorklistSaleLeadApprovalFormComponent } from '../worklist-sale-lead-approval-form/worklist-sale-lead-approval-form.component';
import { WorklistSaleCloseDealFormComponent } from '../worklist-sale-close-deal-form/worklist-sale-close-deal-form.component';
import { TokenService } from '../service/token.service';
import { CompanyInfo } from '../model/company.model';

@Component({
  selector: 'app-worklist-saleapproval',
  templateUrl: './worklist-saleapproval.component.html',
  styleUrls: ['./worklist-saleapproval.component.css']
})
export class WorklistSaleapprovalComponent implements OnInit {
  /********************** Start Variables *********************/
  //General
  baseurl: string;
  _EmpCode: string;
  _ProjCode: string;

  //Search
  isSearchSubmitted: boolean = false;
  txtSearchProjectLeadCode: string;
  txtSearchProjectLeadName: string;
  txtSearchCompany: string = null;

  //For this page
  SaleWorklist_Request: OrganizationApprovalInfo[] = [];
  SaleWorklist_Pending: OrganizationApprovalInfo[] = [];
  SaleWorklist_Completed: OrganizationApprovalInfo[] = [];
  ProjectSaleListDetail: ProjectSaleInfo[] = [];
  CompanyList: CompanyInfo[] = [];

  //Pagination
  currentPageNumber_Request: number;
  currentPageNumber_Pending: number;
  currentPageNumber_Completed: number;
  totalPages_Request: number;
  totalPages_Pending: number;
  totalPages_Completed: number;
  environment: number;
  RequestTotal: number;
  PendingTotal: number;
  CompletedTotal: number;
  idxRequest: number = 0;
  idxPending: number = 0;
  idxComplete: number = 0;


  //Callback view child
  LeadApprovalForm: FormGroup;
  CloseDealForm: FormGroup;
  @ViewChild(WorklistSaleLeadApprovalFormComponent) childLeadApprovalForm: WorklistSaleLeadApprovalFormComponent;
  @ViewChild(WorklistSaleCloseDealFormComponent) childClosedealApprovalForm: WorklistSaleCloseDealFormComponent;
  /********************** End Variables *********************/

  /********************** Start Function *********************/
  constructor(private httpClient: HttpClient, private GlobalService: GlobalService, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {
    this._EmpCode = window.localStorage.getItem('EmpCode');

    this.environment = environment.PageSizeSmall; //For show in front
    this.currentPageNumber_Request = 1;
    this.currentPageNumber_Pending = 1;
    this.currentPageNumber_Completed = 1;
    this.idxRequest = 0;
    this.idxPending = 0;
    this.idxComplete = 0;


    this.OnLoadCountAllList();
    this.LoadRequestList();
    this.LoadPendingList();
    this.LoadCompletedList();

    this.LoadDDLCompany();
  }

  //Load data
  async LoadRequestList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_Request - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['RequestorEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;
      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<OrganizationApprovalInfo[]>(this.baseurl + "ProjectSale/GetRequestSaleWorklist",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SaleWorklist_Request = data.filter(item => item.RequestorEmpCode === this._EmpCode)
        });
    }
  }
  async LoadPendingList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_Pending - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['ApproverEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;
      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<OrganizationApprovalInfo[]>(this.baseurl + "ProjectSale/GetPendingSaleWorklist",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SaleWorklist_Pending = data;
        });
    }
  }
  async LoadCompletedList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_Completed - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['RequestorEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;
      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<OrganizationApprovalInfo[]>(this.baseurl + "ProjectSale/GetCompletedSaleWorklist",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SaleWorklist_Completed = data;
        });
    }
  }

  //Load DDL Company
  async LoadDDLCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";
      await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise()
        .then((data) => {
          this.CompanyList = data.slice().sort((a, b) => a.CompanyName.localeCompare(b.CompanyName));
        });
    }
  }
  
  //Load จำนวนของ Data
  async LoadCountRequestList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RequestorEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;

      let strjson = JSON.stringify(objectjson);


      return this.httpClient
        .post<number>(this.baseurl + "ProjectSale/GetCountRequestSaleWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountPendingList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ApproverEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "ProjectSale/GetCountPendingSaleWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountCompletedList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RequestorEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleCode'] = this.txtSearchProjectLeadCode;
      objectjson['ProjectSaleName'] = this.txtSearchProjectLeadName;
      objectjson['CompanyName'] = this.txtSearchCompany;

      let strjson = JSON.stringify(objectjson);


      return this.httpClient
        .post<number>(this.baseurl + "ProjectSale/GetCountCompletedSaleWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  //Pagination
  OnLoadCountAllList() {

    //Count request list
    this.LoadCountRequestList().then(data => {
      this.RequestTotal = data; //จำนวน data ทั้งหมด
      if(this.RequestTotal == 0) this.currentPageNumber_Request = 1;
      this.totalPages_Request = Math.ceil(this.RequestTotal / environment.PageSizeSmall); //จำนวนที่แบ่ง page ได้
    });

    //Count Pending list 
    this.LoadCountPendingList().then(data => {
      this.PendingTotal = data;//จำนวน data ทั้งหมด
      if(this.PendingTotal == 0) this.currentPageNumber_Pending = 1;
      this.totalPages_Pending = Math.ceil(this.PendingTotal / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
    });

    //Count Completed list
    this.LoadCountCompletedList().then(data => {
      this.CompletedTotal = data;//จำนวน data ทั้งหมด
      if(this.CompletedTotal == 0) this.currentPageNumber_Completed = 1;
      this.totalPages_Completed = Math.ceil(this.CompletedTotal / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
    });
  }
  OnLoadRequestFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_Request = traget.currentPageNumber;
      this.totalPages_Request = traget.totalPages;
      this.idxRequest = traget.index;
      
    }

    this.LoadRequestList();
  }
  OnLoadPendingFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_Pending = traget.currentPageNumber;
      this.totalPages_Pending = traget.totalPages;
      this.idxPending = traget.index;
     
    }

    this.LoadPendingList();
  }
  OnLoadCompletedFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_Completed = traget.currentPageNumber;
      this.totalPages_Completed = traget.totalPages;
      this.idxComplete = traget.index;
    }

    this.LoadCompletedList();
  }
  

  OnBtnSearch_Click(flag: boolean = true) {
    debugger
    this.currentPageNumber_Request = 1;
    this.currentPageNumber_Pending = 1;
    this.currentPageNumber_Completed = 1;
    this.idxRequest = 0;
    this.idxPending = 0;
    this.idxComplete = 0;
    this.isSearchSubmitted = flag;

    this.OnLoadCountAllList();
    this.LoadRequestList();
    this.LoadPendingList();
    this.LoadCompletedList();
  }
  OnBtnClear_Click() {
    this.txtSearchProjectLeadCode = null
    this.txtSearchProjectLeadName = null
    this.txtSearchCompany = null;

    //force reload
    this.OnBtnSearch_Click(false);
  }

  //Import child component for call function
  CreateItemSupportTeamName() {
    return this.formBuilder.group({
      SupporTeamName: [''],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );
  }
  CallbackLoadViewChild(projCode) {
    //call function load ProjectSale list on hand current user
    this._ProjCode = projCode;
    this.childLeadApprovalForm.Click_onViewforUpdateLeadApprove(projCode);
  }
  
  /********************** End Function *********************/

  /*Private Functions*/

}
